import React, { useState } from 'react';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Icons } from '../../base/BootstrapComponents/BootstrapComponents';
import './FileInputStyles.scss';
import { MAX_UPLOAD_FILE_SIZE } from '../../../configs';
import { errorNotification } from '../../../modules/Notifications/notificationDecorator';

export default function UploadZone(props) {
  const {
    inputProps = {},
    zoneText = '',
    className = '',
    // Это не криптография! Если ваш анализатор этого не понимает не используйте этот анализатор
    // nosemgrep
    controlId = `text-input-${Math.random() * 10000}`,
  } = props;
  const { formatMessage } = useIntl();
  const zoneTextBlock = zoneText || formatMessage({ id: 'file.drop' });
  const { onChange = () => {} } = inputProps;
  const [isDragEnter, setDragEnter] = useState(false);
  const dragEnter = evt => {
    setDragEnter(true);
    evt.preventDefault();
    return false;
  };

  const dragLeave = evt => {
    if (evt.currentTarget.contains(evt.relatedTarget)) return;
    setDragEnter(false);
    evt.preventDefault();
    return false;
  };

  const dragOver = evt => {
    evt.preventDefault();
    return false;
  };

  const drop = evt => {
    const files = evt.dataTransfer?.files;
    handleChange({ target: { files } });
    setDragEnter(false);
    evt.preventDefault();
    return false;
  };

  const handleChange = event => {
    const { files = [] } = event.target;
    const result = [];
    for (let i = 0; i < files.length; i++) {
      const file = files[i];
      if (!file) return;
      if (file.size > MAX_UPLOAD_FILE_SIZE) {
        errorNotification('Выбор файла', formatMessage({ id: 'file.input.max.size' }, { name: file.name, size: MAX_UPLOAD_FILE_SIZE / 1024 / 1024 }));
        continue;
      }
      result.push(file);
    }
    onChange(result);
  };

  return (
    <div className={classNames('upload-zone-wrapper', className)}>
      <div
        className={classNames('upload-zone', { active: isDragEnter })}
        onDragEnter={dragEnter}
        onDragLeave={dragLeave}
        onDragOver={dragOver}
        onDrop={drop}
      >
        <div className="upload-zone-icon"><Icons
          width={24}
          height={24}
          customIcon
          icon="download"
          className="button-icons"
        />
        </div>
        <div className="upload-zone-text mt-3">{zoneTextBlock}
        </div>
        <div className="upload-zone-button mt-3">
          <div className="form-control-wrapper button-file-input form-file">
            <input
              type="file"
              className="form-file-input"
              id={controlId}
              aria-describedby={`${controlId}-help`}
              multiple
              onChange={handleChange}
              value=""
            />
            <label className="form-file-label" htmlFor={controlId}>
              <span className="form-file-button">
                {formatMessage({ id: 'select.file' })}
              </span>
            </label>
          </div>
        </div>
      </div>
    </div>
  );
}
